/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { accountMemberOtherSchema } from "./accountMemberOtherSchema.ts";
import { accountMemberRoleSchema } from "./accountMemberRoleSchema.ts";
import { accountOrganizationSchema } from "./accountOrganizationSchema.ts";
import { z } from "zod";

export const accountDataOrganizationSchema = z.lazy(() => accountOrganizationSchema).and(z.object({
      "nombreMembers": z.number().int().optional(),
  "members": z.array(z.lazy(() => accountMemberRoleSchema)).optional(),
  "others": z.array(z.lazy(() => accountMemberOtherSchema).describe("Représentation d'un membre invité mais pas encore inscrit")).optional()
      }))